/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, phrase: NonNullable<unknown> }} Head_Api_Price_DescriptionInputs */

const en_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What the ${i?.name} API costs: ${i?.phrase}, billed per request in USD. No subscription, no monthly minimum, no commitment.`)
};

const zh_hans1_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API 的价格：${i?.phrase}，按请求以美元计费。无需订阅，没有每月最低消费，也没有任何承诺。`)
};

const pt_br2_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preço da API para ${i?.name}: ${i?.phrase}, cobrado por requisição em dólares. Sem assinatura, sem mínimo mensal, sem compromisso.`)
};

const es_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lo que cuesta la API de ${i?.name}: ${i?.phrase}, cobrado por solicitud en USD. Sin suscripción, sin mínimo mensual, sin compromiso.`)
};

const fr_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ce que coûte l’API ${i?.name} : ${i?.phrase}, facturé par requête en USD. Sans abonnement, sans minimum mensuel, sans engagement.`)
};

const de_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was die ${i?.name}-API kostet: ${i?.phrase}, abgerechnet pro Anfrage in USD. Kein Abo, kein monatliches Minimum, keine Bindung.`)
};

const ru_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сколько стоит API ${i?.name}: ${i?.phrase}, оплата за запрос в долларах США. Без подписки, без ежемесячного минимума, без обязательств.`)
};

const it_head_api_price_description = /** @type {(inputs: Head_Api_Price_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto costa l'API di ${i?.name}: ${i?.phrase}, fatturato a richiesta in USD. Nessun abbonamento, nessun minimo mensile, nessun vincolo.`)
};

/**
* | output |
* | --- |
* | "What the {name} API costs: {phrase}, billed per request in USD. No subscription, no monthly minimum, no commitment." |
*
* @param {Head_Api_Price_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const head_api_price_description = /** @type {((inputs: Head_Api_Price_DescriptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Head_Api_Price_DescriptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_head_api_price_description(inputs)
	if (locale === "pt-BR") return pt_br2_head_api_price_description(inputs)
	if (locale === "es") return es_head_api_price_description(inputs)
	if (locale === "fr") return fr_head_api_price_description(inputs)
	if (locale === "de") return de_head_api_price_description(inputs)
	if (locale === "ru") return ru_head_api_price_description(inputs)
	if (locale === "it") return it_head_api_price_description(inputs)
	return en_head_api_price_description(inputs)
});